import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.197 33.209c2.07-2.783 4.55-9.793-1.457-14.919 3.636-1.38 11.806-5.352 14.757-10.84.518 3.203-.874 12.75-8.575 17.442 1.124.17 1.561.105 2.686-.55-.378 2.686-2.389 8.97-7.411 12.62.291-1.65.259-2.135 0-3.753ZM17.31 18.29c-6.006 5.126-3.527 12.136-1.456 14.919-.26 1.618-.291 2.103 0 3.754-5.023-3.65-7.033-9.935-7.41-12.621 1.124.655 1.56.72 2.685.55C3.427 20.2 2.036 10.653 2.553 7.449c2.952 5.489 11.122 9.46 14.757 10.841Zm14.142 8.285a7.508 7.508 0 1 1-15.016 0 7.508 7.508 0 0 1 15.016 0Z" fill="#8C513A"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
